<template>
  <div>
    <div align="left">
    <el-button type="primary" @click="returnPage">返回</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">

      <!--<el-table-column-->
        <!--fixed-->
        <!--prop="id"-->
        <!--label="ID"-->
        <!--width="80">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="box"
        label="投放箱"
        width="86">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.box<4?'danger':'warning'" effect="dark"
            disable-transitions>{{(scope.row.box<4?'感染性'+scope.row.box:'损伤性'+scope.row.box)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="hospital"
        label="医疗企业"
        width="380">
      </el-table-column>
      <el-table-column
        prop="time"
        label="投放时间"
        width="135">
      </el-table-column>
      <el-table-column
        prop="user"
        label="投放人"
        width="80">
      </el-table-column>
      <el-table-column
        prop="weight"
        label="重量kg"
        width="70">
      </el-table-column>

      <el-table-column
        prop="state"
        label="状态"
        width="100">
        <template slot-scope="scope">
          <!--{{scope.row.state===2?'正在收取':''}}-->

          <el-tag v-if="scope.row.state===2"
          type=""
            disable-transitions>收取中</el-tag>
          <el-tag v-if="scope.row.err"
                  type="danger"
                  disable-transitions>计重存疑</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="remarks"
        label="备注"
        width="300">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="ip"-->
        <!--label="最后登陆IP"-->
        <!--width="130">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="sn"-->
        <!--label="SN"-->
        <!--width="130">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="creator"-->
        <!--label="注册者"-->
        <!--width="130">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--fixed="right"-->
        <!--label="操作"-->
        <!--width="220">-->
        <!--<template slot-scope="scope">-->
          <!--<el-button-->
            <!--@click.native.prevent="changeEnable(scope.$index, tableData)"-->
            <!--size="mini" :type="tableData[scope.$index].state&1==1?'danger':'success'" >-->
            <!--{{tableData[scope.$index].state&1==1?"停用":"启用"}}-->
          <!--</el-button>-->
          <!--&lt;!&ndash;<el-button&ndash;&gt;-->
          <!--&lt;!&ndash;@click.native.prevent="changeEnable(scope.$index, tableData)"&ndash;&gt;-->
          <!--&lt;!&ndash;size="mini" :type="tableData[scope.$index].state&2==2?'danger':'success'" >&ndash;&gt;-->
          <!--&lt;!&ndash;{{tableData[scope.$index].state&2==2?"开始维护":"维护完成"}}&ndash;&gt;-->
          <!--&lt;!&ndash;</el-button>&ndash;&gt;-->
        <!--</template>-->
      <!--</el-table-column>-->
    </el-table>
    <!--<div class="block">-->
      <!--<el-pagination-->
        <!--@size-change="handleSizeChange"-->
        <!--@current-change="handleCurrentChange"-->
        <!--:current-page="page"-->
        <!--:page-sizes="[10,20,50,100]"-->
        <!--:page-size="pageSize"-->
        <!--layout="total, sizes, prev, pager, next, jumper"-->
        <!--:total="total">-->
      <!--</el-pagination>-->
    <!--</div>-->
  </div>
</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      returnPage(){

        this.$router.go(-1);

      },
      // init() {
      //   let $this=this;
      //   window.ws.AddFunc("S2W_GetTerminalDataRes",function (code,err,currentPage,total,list) {
      //     console.log("S2W_GetTerminalDataRes:",code,err,currentPage,total,list)
      //     if (code==coder.OK){
      //       $this.page=currentPage;
      //       $this.total=total;
      //       $this.tableData=list;
      //     }
      //   });
      //   window.ws.Call("W2S_GetTerminalDate",this.$route.query.id);
      //
      //
      //   console.log("W2S_GetTerminalDate",this.$route.query.id)
      // },
      // changeEnable(index, rows) {
      //   if (rows[index].state&1==1){
      //     rows[index].state^=1
      //   }else{
      //     rows[index].state|=1
      //   }
      // },
      // handleSizeChange(e){
      //   this.pageSize=e;
      //   window.ws.Call("W2S_UserList",this.page,this.pageSize);
      // },
      // handleCurrentChange(e){
      //   this.page=e;
      //   window.ws.Call("W2S_UserList",this.page,this.pageSize);
      // }
    },
    mounted() {
      let $this=this;
      window.ws.AddFunc("S2W_GetTerminalDataRes",function (code,list) {
        console.log("S2W_GetTerminalDataRes:",code,list)
        if (code==coder.OK){
          // $this.page=currentPage;
          // $this.total=total;
          $this.tableData=list;
        }
      });
      window.ws.Call("W2S_GetTerminalDate",this.$route.params.id);
      console.log("W2S_GetTerminalDate",this.$route.params.id)
    },
    data() {
      return {
        page:1,
        pageSize:10,
        total:0,
        tableData: []
        // tableData: [{
        //   "id":1,
        //   "weight":200,
        //   "err":false,
        //   "confirm":true,
        //   "time":"2021-06-21 15:20",
        //   "hospital":"123",
        //   "box":1,
        //   "remarks":"",
        //   "user":"user",
        //   "state":1,
        // },{
        //   "id":2,
        //   "weight":100,
        //   "err":true,
        //   "confirm":true,
        //   "time":"2021-06-21 15:30",
        //   "hospital":"123",
        //   "box":4,
        //   "remarks":"",
        //   "user":"user",
        //   "state":2,
        // }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/terminalData.vue